import { render } from "./Barcode.vue?vue&type=template&id=54640efe&scoped=true"
import script from "./Barcode.vue?vue&type=script&lang=js"
export * from "./Barcode.vue?vue&type=script&lang=js"

import "./Barcode.vue?vue&type=style&index=0&id=54640efe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54640efe"]])

export default __exports__